import { useEffect } from 'react'
// import { createBrowserRouter, createRoutesFromElements, Route, Outlet, useLocation } from 'react-router-dom'
import { createRoutesFromElements, Route, Outlet, useLocation } from 'react-router-dom'
import AOS from 'aos'
//import { useTextReveal,useTextRevealLines} from '@helpers/useIntersectionObserver'
import { ThemeProvider } from '@helpers/ThemeContext'
import Navbar from '@layout/Navbar'
import Footer from '@layout/Footer'
import ScrollToTop from '@common/ScrollToTop'
import HomePage      from '@pages/HomePage'

import SalesEnquiry   from '@pages/SalesEnquiry'
import NotFoundPage  from '@pages/NotFoundPage'

//Know Us pages
import AboutUsPage from '@pages/AboutUs'
import Policies   from '@pages/Policies'
import PartnershipsPage from '@pages/PartnershipsPage'
import JobApplication from '@pages/JobApplication'
// import LeadershipPage from '@pages/LeadershipPage'
import CareersPage from '@pages/Careers'

// Consulting pages
import SoftwareConsulting from '@pages/SoftwareConsulting'
//import CloudConsulting from '@pages/CloudConsulting'
//import LegacySystemModernization from '@pages/LegacySystemModernization'
import SecurityComplianceAdvisory from '@pages/SecurityComplianceAdvisory'
import AIStrategyConsulting from '@pages/AIStrategyConsulting'
import CTOService from '@pages/CTOService'

//design pages
import UIUXDesign from '@pages/UIUXDesign'
import ProductExperienceDesign from '@pages/ProductExperienceDesign'

//Software Development pages
import OnDemandAppDevelopment from '@pages/OnDemandAppDevelopment'
import SaasPlatformDevelopment from '@pages/SaasPlatformDevelopment'
import EGovernance from '@pages/EGovernance'
import ApplicationModernization from '@pages/ApplicationModernization'

//Software Testing & QA pages
import FunctionalTesting from '@pages/FunctionalTesting'
import PerformanceTesting from '@pages/PerformanceTesting'
import APITesting from '@pages/APITesting'

//Maintenance & Support pages
import SoftwareMaintenanceSupportAMC from '@pages/SoftwareMaintenanceSupportAMC'
import DevOps from '@pages/DevOps'
import CloudServices from '@pages/CloudServices'
import DomainDNSEmailServerManagement from '@pages/DomainDNSEmailServerManagement'

//Staff Augmentation pages
import HireDedicatedDevelopers from '@pages/HireDedicatedDevelopers'

//AI/ML Solutions pages
import AiIntegrationApplicationDevelopment from '@pages/AiIntegrationApplicationDevelopment'
import GenAIIntelligentAssistants from '@pages/GenAIIntelligentAssistants'
import AiWorkflowAutomation from '@pages/AiWorkflowAutomation'
import AiMachineLearning from '@pages/AiMachineLearning'
import AiUseCases from '@pages/AiUseCases'

// Portfolio pages
import OurExpertise from '@pages/OurExpertise'
import OurWork from '@pages/OurWork'
import ClientCorner from '@pages/ClientCorner'

// import PortfolioPage from '@pages/PortfolioPage'
import SiteMap  from '@pages/SiteMap'
// import KnowUs from '@pages/KnowUs'
import Sample from '@pages/Sample'
import { crumbFor } from './assets/js/navBreadcrumb'
import { ROUTES } from './constants';
/* Resets scroll to top on every route change — runs once globally */
// function RouteScrollReset() {
//   const { pathname } = useLocation()
//   useEffect(() => {
//     window.scrollTo(0, 0)
//     if (typeof window.gtag === 'function') {
//       window.gtag('config', 'G-XXXXXXXXXX', { page_path: pathname })
//     }
//   }, [pathname])
//   return null
// }
function RootLayout() {
  //useTextReveal() 
  // useTextRevealLines()
  useEffect(() => {
    AOS.init({ duration: 650, once: true, easing: 'ease-out-cubic', offset: 60 })
  }, [])
   const { pathname, hash } = useLocation()
 useEffect(() => {
    if (!hash) window.scrollTo(0, 0)
  }, [pathname, hash])
  return (
    <ThemeProvider>
      {/* <RouteScrollReset /> */}
      <Navbar />
      <Outlet />
      <div className="footer-grid-host">
        <div className="footer-grid" aria-hidden="true" />
        <Footer />
      </div>
      <ScrollToTop />
    </ThemeProvider>
  )
}

// Each route's `handle.crumb` is the full breadcrumb trail (excluding
// "Home", which Breadcrumb.jsx always prepends) for that page, read via
// React Router's `useMatches()` hook — the standard "route metadata"
// breadcrumb pattern.
//const router = createBrowserRouter(
export const routes = (
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      {/* ── Core pages ── */}<Route path={ROUTES.HOME} element={<HomePage />} />
<Route path={ROUTES.OUR_LEGACY} element={<AboutUsPage />} handle={{ crumb: crumbFor(ROUTES.OUR_LEGACY) }} />
{/* <Route path={ROUTES.SALES_ENQUIRY} element={<SalesEnquiry />} handle={{  crumb: ["Sales Enquiry"] }} /> */}
 <Route path={ROUTES.SALES_ENQUIRY} element={<SalesEnquiry />} handle={{ crumb: [{ label: 'Sales Enquiry', href: null }] }} />
<Route path={ROUTES.BE_A_PARTNER} element={<PartnershipsPage />} handle={{ crumb: crumbFor(ROUTES.BE_A_PARTNER) }} />
<Route path={ROUTES.POLICIES}      element={<Policies />}     handle={{ crumb: [{ label: 'Policies', href: null }] }} />
<Route path={ROUTES.APPLY_FOR_JOB}        element={<JobApplication />}   handle={{ crumb: [{ label: 'Apply for Job', href: null }] }} />
{/* <Route path={ROUTES.LEADERSHIP} element={<LeadershipPage />} handle={{ crumb: crumbFor(ROUTES.LEADERSHIP) }} /> */}
<Route path={ROUTES.CAREERS} element={<CareersPage />} handle={{ crumb: crumbFor(ROUTES.CAREERS) }} />

{/* Consulting pages */}
<Route path={ROUTES.SOFTWARE_CONSULTING} element={<SoftwareConsulting />} handle={{ crumb: crumbFor(ROUTES.SOFTWARE_CONSULTING) }} />
{/* <Route path={ROUTES.CLOUD_CONSULTING} element={<CloudConsulting />} handle={{ crumb: crumbFor(ROUTES.CLOUD_CONSULTING) }} /> */}
{/* <Route path={ROUTES.LEGACY_SYSTEM_MODERNIZATION} element={<LegacySystemModernization />} handle={{ crumb: crumbFor(ROUTES.LEGACY_SYSTEM_MODERNIZATION) }} /> */}
<Route path={ROUTES.SECURITY_COMPLIANCE_ADVISORY} element={<SecurityComplianceAdvisory />} handle={{ crumb: crumbFor(ROUTES.SECURITY_COMPLIANCE_ADVISORY) }} />
<Route path={ROUTES.AI_STRATEGY_CONSULTING} element={<AIStrategyConsulting />} handle={{ crumb: crumbFor(ROUTES.AI_STRATEGY_CONSULTING) }} />
<Route path={ROUTES.CTO_AS_A_SERVICE} element={<CTOService />} handle={{ crumb: crumbFor(ROUTES.CTO_AS_A_SERVICE) }} />

{/* design pages */}
<Route path={ROUTES.UI_UX_DESIGN} element={<UIUXDesign />} handle={{ crumb: crumbFor(ROUTES.UI_UX_DESIGN) }} />
<Route path={ROUTES.PRODUCT_EXPERIENCE_DESIGN} element={<ProductExperienceDesign />} handle={{ crumb: crumbFor(ROUTES.PRODUCT_EXPERIENCE_DESIGN) }} />

{/* Software Development pages */}
<Route path={ROUTES.ON_DEMAND_APP_DEVELOPMENT} element={<OnDemandAppDevelopment />} handle={{ crumb: crumbFor(ROUTES.ON_DEMAND_APP_DEVELOPMENT) }} />
<Route path={ROUTES.SAAS_PLATFORM_DEVELOPMENT} element={<SaasPlatformDevelopment />} handle={{ crumb: crumbFor(ROUTES.SAAS_PLATFORM_DEVELOPMENT) }} />
<Route path={ROUTES.EGOVERNANCE} element={<EGovernance />} handle={{ crumb: crumbFor(ROUTES.EGOVERNANCE) }} />
<Route path={ROUTES.APPLICATION_MODERNIZATION} element={<ApplicationModernization />} handle={{ crumb: crumbFor(ROUTES.APPLICATION_MODERNIZATION) }} />

{/* Software Testing & QA pages */}
<Route path={ROUTES.FUNCTIONAL_TESTING} element={<FunctionalTesting />} handle={{ crumb: crumbFor(ROUTES.FUNCTIONAL_TESTING) }} />
<Route path={ROUTES.PERFORMANCE_TESTING} element={<PerformanceTesting />} handle={{ crumb: crumbFor(ROUTES.PERFORMANCE_TESTING) }} />
<Route path={ROUTES.API_TESTING} element={<APITesting />} handle={{ crumb: crumbFor(ROUTES.API_TESTING) }} />

{/* Maintenance & Support pages */}
{/* <Route path={ROUTES.AMC} element={<SoftwareMaintenanceSupportAMC />} handle={{ crumb: ['IT Services', 'Maintenance & Support', 'Software Maintenance and Support / AMC'] }} /> */}
<Route path={ROUTES.AMC} element={<SoftwareMaintenanceSupportAMC />} handle={{ crumb: crumbFor(ROUTES.AMC) }} />
<Route path={ROUTES.DEVOPS} element={<DevOps />} handle={{ crumb: crumbFor(ROUTES.DEVOPS) }} />
<Route path={ROUTES.CLOUD_SERVICES} element={<CloudServices />} handle={{ crumb: crumbFor(ROUTES.CLOUD_SERVICES) }} />
<Route path={ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT} element={<DomainDNSEmailServerManagement />} handle={{ crumb: crumbFor(ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT) }} />

{/* Staff Augmentation pages */}
<Route path={ROUTES.STAFF_AUGMENTATION} element={<HireDedicatedDevelopers />} handle={{ crumb: crumbFor(ROUTES.STAFF_AUGMENTATION) }} />

{/* AI/ML Solutions pages */}
<Route path={ROUTES.AI_INTEGRATION_APPLICATION_DEVELOPMENT} element={<AiIntegrationApplicationDevelopment />} handle={{ crumb: crumbFor(ROUTES.AI_INTEGRATION_APPLICATION_DEVELOPMENT) }} />
<Route path={ROUTES.GENAI_INTELLIGENT_ASSISTANTS} element={<GenAIIntelligentAssistants />} handle={{ crumb: crumbFor(ROUTES.GENAI_INTELLIGENT_ASSISTANTS) }} />
<Route path={ROUTES.AI_WORKFLOW_AUTOMATION_AGENTS} element={<AiWorkflowAutomation />} handle={{ crumb: crumbFor(ROUTES.AI_WORKFLOW_AUTOMATION_AGENTS) }} />
<Route path={ROUTES.AI_MACHINE_LEARNING_SOLUTIONS} element={<AiMachineLearning />} handle={{ crumb: crumbFor(ROUTES.AI_MACHINE_LEARNING_SOLUTIONS) }} />
<Route path={ROUTES.AI_USECASES_BUSINESS_APPLICATIION} element={<AiUseCases />} handle={{ crumb: crumbFor(ROUTES.AI_USECASES_BUSINESS_APPLICATIION) }} />

{/* portfolio pages */}
{/* <Route path="/portfolio" element={<PortfolioPage />} handle={{ crumb: crumbFor("/portfolio") }} /> */}
{/* <Route path={ROUTES.KNOW_US} element={<KnowUs />}  handle={{ crumb: [{ label: 'Know Us', href: null }] }}/> */}
<Route path={ROUTES.OUR_WORK} element={<OurWork />} handle={{ crumb: crumbFor(ROUTES.OUR_WORK) }} />
<Route path={ROUTES.OUR_EXPERTISE} element={<OurExpertise />} handle={{ crumb: crumbFor(ROUTES.OUR_EXPERTISE) }} />
<Route path={ROUTES.CLIENT_CORNER} element={<ClientCorner />} handle={{ crumb: crumbFor(ROUTES.CLIENT_CORNER) }} />
<Route path={ROUTES.SITEMAP}  element={<SiteMap />}  handle={{ crumb: [{ label: 'Sitemap', href: null }] }} />
<Route path="/sample"  element={<Sample />}   />
{/* ── 404 ── */}
<Route path="404" element={<NotFoundPage />} />
<Route path="*" element={<NotFoundPage />} />
    </Route>
  )
)

// export default router